// extracted by mini-css-extract-plugin
module.exports = {"headerContent":"N_77PwwI","title":"_qN9To8_","subTitle":"_rSAYLBf","orange":"bzb_HOSL"};